import { BackendModule } from 'i18next';

interface I18nBackendOptions {
  loadPath?: string;
  localResources?: { [key: string]: Object };
}

/* eslint-disable-next-line */
interface EdBackendModule<TOptions = object> extends BackendModule {
  services: any;
  backendOptions: I18nBackendOptions;
  i18nextOptions: Object;
}

const XHR: EdBackendModule<I18nBackendOptions> = {
  type: 'backend',

  services: null,
  backendOptions: {},
  i18nextOptions: {},

  init: function (services, backendOptions = {}, i18nextOptions = {}) {
    XHR.services = services;
    XHR.backendOptions = backendOptions;
    XHR.i18nextOptions = i18nextOptions;
  },

  read: async function (language, namespace, callback) {
    if (language === 'dev') {
      callback(null, {});
      return;
    }

    const remoteUrl = XHR.backendOptions.loadPath;
    const localResources = XHR.backendOptions.localResources;
    const localResource = localResources ? localResources[language] || {} : {};

    try {
      const response = await fetch(remoteUrl!.replace('{{lng}}', language));
      let remoteResource = await response.json();
      callback(null, Object.assign(localResource, remoteResource.data));
    } catch (e) {
      callback(null, Object.assign(localResource, {}));
    }
  },

  create: function (languages, namespace, key, fallbackValue) {
    /* save the missing translation */
  },
};

export default XHR;
